export class AssetBasisApiModel {
  account = '';
  id = 0;
  name = '';
  tax = '';
}
